import { useDashboardContext } from '../../../../dashboard/context';
import {useClearStudentPasswordMutation} from '../../../../../features/authentication/studentApiSlice';
import CustomToast from '../../../../../components/Toast';
import {useMoveStudentsMutation, useRemoveStudentsMutation, useRestoreStudentsMutation, useSaveCalendarURLMutation, useTransferOwnerShipMutation} from '../../../../../features/authentication/classesApiSlice';
export const useClassManagementActions =() =>
{
  const messageContext = useDashboardContext();
  const [clearStudentpassword] = useClearStudentPasswordMutation();
  const [moveStudents] = useMoveStudentsMutation();
  const [removeStudents] = useRemoveStudentsMutation();
  const [restoreStudents] = useRestoreStudentsMutation();
  const [transferOwnership] = useTransferOwnerShipMutation();
  const [saveCalendarURL] = useSaveCalendarURLMutation();

  const sendMessageAction = (students) => {
    messageContext.setSlectedStudents(students);
    messageContext.setSendEmailModal(true);
    messageContext.setIsReplayMessage(false);
  };

  const clearPasswordAction = async (students, classId, loadStudents)=>
  {
    const options=
    {
      studentIds : students.map(x=>x.studentId),
      classId : classId
    };
    var response = await clearStudentpassword(options);
    if(response.error?.data?.errors)
    {
      CustomToast(response.error.data.title, 'error');
      return;
    }
    else if (response.error) {
      CustomToast(response.error.data.error, 'error');
      return;
    }
    CustomToast('The password(s) has been cleared. The student(s) will be prompted for a new password upon next login., ', 'success');
    loadStudents();
  };

  const moveAction = async (students, classId, toClassId, loadStudents)=>
  {
    if(!toClassId)
      return;
    
    const options=
    {
      id : classId,
      toClassId : toClassId,
      studentIds : students.map(x=>x.studentId),
    };
    var response = await moveStudents(options);
    if(response.error?.data?.errors)
    {
      CustomToast(response.error.data.title, 'error');
      return;
    }
    else if (response.error) {
      CustomToast(response.error.data.error, 'error');
      return;
    }
    CustomToast('Moved Successfully', 'success');
    loadStudents();
  };

  const hideAction = async (students, classId, loadStudents)=>
  {
    const options=
    {
      studentIds : students.map(x=>x.studentId),
      id : classId
    };
    try{
      await removeStudents(options).unwrap();
    }catch(exception)    {
      return;
    }
    CustomToast(`${students.length>1?'Selected Students are':students[0].lName +' '+ students[0].fName } Hidden Successfully`, 'success');
    loadStudents();
  };

  const unhideAction = async (students, classId, loadStudents)=>
  {
    const options=
    {
      studentIds : students.map(x=>x.studentId),
      id : classId
    };

    try{
      await restoreStudents(options).unwrap();
    }catch(exception)    {
      return;
    }
    CustomToast(`${students.length>1?'Selected Students are':students[0].lName +' '+ students[0].fName } Unhidden Successfully`, 'success');
    loadStudents();
  };


  const transferOwnershipAction = async (classId, transferToId, transferAssignments, stayAsCoTeacher)=>
  {
    const options=
    {
      id: classId,
      teacherId: transferToId,
      transferAssignments: transferAssignments,
      stayAsCoTeacher: stayAsCoTeacher
    };
    var response = await transferOwnership(options);
    if(response.error?.data?.errors)
    {
      CustomToast(response.error.data.title, 'error');
      return;
    }else if (response.error) {
      CustomToast(response.error.data.error, 'error');
      return(false);
    }
    CustomToast('The class now belongs to the selected teacher.', 'success');
    return(true);
  };

  const saveGoogleCalendarLinkAction = async (classId, calendarLink) =>
  {
    const options=
    {
      id:classId,
      url:calendarLink
    };
    var response = await saveCalendarURL(options);
    if(response.error.data.errors)
    {
      CustomToast(response.error?.data?.title, 'error');
      return;
    }else if (response.error) {
      CustomToast(response.error.data.error, 'error');
      return;
    }
    CustomToast('Google Calendar URL Saved Successfully.', 'success');
  };

  return {
    sendMessageAction,
    clearPasswordAction,
    moveAction,
    hideAction,
    unhideAction,
    transferOwnershipAction,
    saveGoogleCalendarLinkAction
  };
};